<template>
    <mdc-dialog v-model="isOpen"
                :title="'user.add_therapist' | trans" :accept="'user.add' | trans"
                :cancel="'user.cancel' | trans"
                :accept-disabled="isAcceptDisabled"
                @accept="accept" @cancel="close" @validate="save">
        <div class="container" v-if="!isLoaded">
            <loader class="table-loader"></loader>
        </div>
        <div class="close-cross" @click="close()">
            <mdc-icon icon="close"></mdc-icon>
        </div>
        <div class="container" v-if="isLoaded">
            <div v-if="isListEmpty">{{'user.add_therapist_no_data' | trans}}</div>
            <form novalidate v-if="!isListEmpty">
                <div class="form-group row">
                    <div class="col-md-12">
                        <select-with-pager id="mdc-therapist"
                                           name="therapist"
                                           class="load_more__select"
                                           :label="'displayName'"
                                           :selected=therapistId
                                           :options="therapists"
                                           :class="{'is-invalid': errors.has('therapist'), 'is-clear': !therapistId}"
                                           :filterable="false"
                                           :searchable="false"
                                           :loading=loading
                                           :isLastPage=isLastPage
                                           v-on:next-page="nextPage"
                                           v-on:set-selected="onSetSelected"
                                           v-bind:getOptionTitle="getOptionTitle"
                                           v-bind:isLast="isLast">
                        </select-with-pager>
                        <label class="mdc-floating-label" :class="{ 'mdc-floating-label-error': errors.has('therapist') }">{{ 'user.choose_therapist_from_list' | trans }}</label>
                        <span class="invalid-feedback" v-if="errors.has('therapist_id')">
                           {{ errors.first('therapist_id') }}
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </mdc-dialog>
</template>

<script>
  import ApiManager from '../../../api/Manager';
  import Loader from '../../../../../../loader/components/Loader';
  import selectWithPager from '../../../../../../../common/selectWithPager/components/SelectWithPager';

  export default {
    name: 'AddTherapistModal',
    components: {Loader, selectWithPager},
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      curatorId: {
        type: [Number, String],
        default() {
          return this.$route.params.id || null;
        },
      },
    },
    data() {
      return {
        therapists: [],
        api: null,
        therapistId: null,
        isLoaded: false,
        disabled: true,
        isLastPage: false,
        loading: false,
        perPage: 5,
        page: 1,
        lastId: null
      };
    },
    created() {
      this.api = new ApiManager(this.curatorId);
    },
    beforeDestroy() {
      this.api = null;
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {},
      },
      isListEmpty() {
        return !this.therapists.length;
      },
      isAcceptDisabled() {
        return this.disabled || this.isListEmpty;
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
      accept() {
        this.$emit('accept');
      },
      async save({accept}) {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }
        try {
          await this.api.addTherapist(this.therapistId.id);
          accept();
        } catch (e) {
          console.error(e);
          this.disabled = false;
        }
      },


      nextPage: async function () {
        if (!this.isLastPage) {
          this.loading = true;
          let response = await this.api.getNotOwnTherapists(this.perPage, this.page)

          response.data.data.items.forEach((item) => {
            this.therapists.push(item)
          });

          this.loading = false;
          this.lastId = this.therapists[this.therapists.length - 1].id;
          if (response.data.data.lastPage != this.page) {
            this.page++;
          } else {
            this.isLastPage = true;
          }
        }
      },

      onSetSelected: function (selected) {
          this.therapistId = selected
      },

      getOptionTitle: function ({option}) {
        return option.displayName;
      },

      isLast: function ({option}) {
        return option.id == this.lastId;
      },

    },
    watch: {
      visible: async function(val) {
        this.isLoaded = false;
        this.disabled = true;
        if (val) {
          try {
            let response = await this.api.getNotOwnTherapists(this.perPage, this.page);
            this.therapists = response.data.data.items;
            this.lastId = this.therapists[this.therapists.length - 1].id;

            if (response.data.data.hasMorePages) {
              this.page++;
            } else {
              this.isLastPage = true;
            }
          } catch (e) {
            console.error(e);
          }
        } else {
          this.therapists = [];
        }
        this.isLoaded = true;
        this.disabled = false;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/user/curator/profile/components/list/modals/AddTherapistModal.vue